import { Grid, GridItem, Heading, JourneyHeader, Text, } from '@imported/constellation';
import React from 'react';
import useIsWebView from '../../hooks/useIsWebView/index.js';
import { HeadingWrapper, PageHeadingWrapper } from './styles.js';
const PageHeading = ({ pageTitle, journeyTitle }) => {
    const isWebView = useIsWebView();
    return (React.createElement(HeadingWrapper, null,
        React.createElement(Grid, null,
            React.createElement(GridItem, null,
                React.createElement(JourneyHeader, null,
                    journeyTitle && !isWebView && (React.createElement(Text, { "data-testid": 'journeyTitle', size: 's2', weight: 'bold' }, journeyTitle)),
                    pageTitle && (React.createElement(PageHeadingWrapper, { styleCondition: isWebView },
                        React.createElement(Heading, { "data-testid": 'pageTitle', id: 'heading', size: 's7' }, pageTitle))))))));
};
export default PageHeading;
//# sourceMappingURL=index.js.map